import { Box } from "@mui/material";
import React, { useState } from "react";
import { serializeChildren } from "utils/markdown";
import ContentEditorButton from "./ContentEditorButton";

export default function EditableBox({ children, updateParagraph, sx }) {

  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      component="p"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        padding: "8px",
        backgroundColor: isHovered ? "rgba(255, 255, 255, 0.05)" : "transparent",
        transition: "background-color 0.3s ease",
        marginBottom: "16px",
        position: "relative",
        ...sx,
      }}
    >
      {isHovered && (
        <ContentEditorButton 
          paragraphContent={serializeChildren(children)}
          updateParagraph={updateParagraph}
        />
      )}
      {children}
    </Box>
  );
}
